module.exports = __webpack_public_path__ + "static/media/test project by dev on 10-6-2020-2_1632919500720.4e4c1a0c.vtt";